import React, { useEffect, useState, useRef } from "react";
import classes from './Payables.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Clock, CreditCard } from "lucide-react";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import crop from "../../Assets/repoort.png";
import Modal from './Modal'
import verified from "../../Assets/verified.svg";
import Swal from "sweetalert2";

const Payables = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const handleShow1 = () => setShow1(true);
    const handleShow2 = () => setShow2(true);
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    const [selectedRadio, setSelectedRadio] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [paymentDate, setPaymentDate] = useState("");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState("");
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);
    const [bankOptions2, setBankOptions2] = useState([]);
    const [paymentMode, setPaymentMode] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [selectedBank, setSelectedBank] = useState(null);
    const [selectedBank2, setSelectedBank2] = useState(null);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [invoiceOptions, setInvoiceOptions] = useState([]);
    const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
    const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);


    const printRef = useRef();
    const data = [
        {
            invoice: "REC-001",
            supplier: "Dangote Group",
            invoiceDate: "2025-01-15",
            dueDate: "2025-02-14",
            originalAmount: "₦2,500,000.00",
            outstanding: "₦0.00",
            overdue: null,
            status: "Cash",
        },
        {
            invoice: "REC-001",
            supplier: "Dangote Group",
            invoiceDate: "2025-01-15",
            dueDate: "2025-02-14",
            originalAmount: "₦2,500,000.00",
            outstanding: "₦2,500.00",
            overdue: "18",
            status: "Cheque",
        },
        {
            invoice: "REC-001",
            supplier: "Dangote Group",
            invoiceDate: "2025-01-15",
            dueDate: "2025-02-14",
            originalAmount: "₦2,500,000.00",
            outstanding: "₦2,500.00",
            overdue: null,
            status: "Transfer",
        },
        {
            invoice: "REC-001",
            supplier: "Dangote Group",
            invoiceDate: "2025-01-15",
            dueDate: "2025-02-14",
            originalAmount: "₦2,500,000.00",
            outstanding: "₦0.00",
            overdue: null,
            status: "Cash",
        },
        {
            invoice: "REC-001",
            supplier: "Dangote Group",
            invoiceDate: "2025-01-15",
            dueDate: "2025-02-14",
            originalAmount: "₦2,500,000.00",
            outstanding: "₦0.00",
            overdue: null,
            status: "Cash",
        },
        {
            invoice: "REC-001",
            supplier: "Dangote Group",
            invoiceDate: "2025-01-15",
            dueDate: "2025-02-14",
            originalAmount: "₦2,500,000.00",
            outstanding: "₦0.00",
            overdue: null,
            status: "Cash",
        },
    ];


    const fetchInvoices = React.useCallback(async () => {
        try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/fetch-payable`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );
            if (res.data && res.data.status && Array.isArray(res.data.data)) {
                setInvoices(res.data.data);
            }
        } catch (err) {
            setInvoices([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchInvoices();
    }, [fetchInvoices]);

    // useEffect(() => {
    //     fetchInvoices();
    //   }, []);



    const statusClass = (status) => {
        if (status === "Success") return classes.greenStatus;
        if (status === "Pending") return classes.yellowStatus;
        return classes.redStatus;
    };


    const handlePrint = (rowData) => {
        navigate("/invoice-previeww", {
            state: { invoice: rowData },
        });
    };
    // Replace the existing fetchCurrencies useEffect with this improved version
    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });

                const options = Array.isArray(res.data.data)
                    ? res.data.data.map((item) => ({
                        value: item.id,
                        label: item.name || item.code,
                        code: item.code,
                    }))
                    : [];

                console.log("Currency options:", options);

                setCurrencyOptions(options);

                // More robust NGN default selection
                const ngnOption = options.find(opt => {
                    const code = opt.code?.toUpperCase();
                    const label = opt.label?.toUpperCase();

                    return (
                        code === "NGN" ||
                        label === "NGN" ||
                        label?.includes("NAIRA") ||
                        label?.includes("NIGERIAN") ||
                        code === "566" // ISO numeric code for NGN
                    );
                });

                if (ngnOption) {
                    setSelectedCurrency(ngnOption);
                    console.log("NGN set as default currency:", ngnOption);
                } else {
                    // Fallback: if NGN not found, log available currencies for debugging
                    console.log("NGN not found. Available currencies:", options.map(opt => ({ code: opt.code, label: opt.label })));

                    // Optional: Set first currency as default if NGN is not available
                    if (options.length > 0) {
                        setSelectedCurrency(options[0]);
                    }
                }

            } catch (err) {
                console.error("Error fetching currencies:", err);
                setCurrencyOptions([]);
            }
        };

        fetchCurrencies();
    }, []);

    // Alternative approach: You can also set NGN as default in both modal states
    // Add this useEffect to ensure NGN is selected when modals open
    useEffect(() => {
        if ((show1 || show2 || isOpen) && currencyOptions.length > 0 && !selectedCurrency) {
            const ngnOption = currencyOptions.find(opt => {
                const code = opt.code?.toUpperCase();
                const label = opt.label?.toUpperCase();

                return (
                    code === "NGN" ||
                    label === "NGN" ||
                    label?.includes("NAIRA") ||
                    label?.includes("NIGERIAN")
                );
            });

            if (ngnOption) {
                setSelectedCurrency(ngnOption);
            }
        }
    }, [show1, show2, isOpen, currencyOptions, selectedCurrency]);

    // Also, make sure to reset selectedCurrency when closing modals if needed
    // Update your handleClose functions:
    // const handleClose1 = () => {
    //     setShow1(false);
    //     // Reset form fields
    //     setDescription("");
    //     setAmount("");
    //     setCustomerName("");
    //     setPaymentDate("");
    //     setSelectedRadio("");
    //     setSelectedBank(null);
    //     setSelectedBank2(null);
    //     setSelectedCustomer(null);
    //     setSelectedPaymentMode(null);
    //     // Keep NGN selected or reset to NGN
    //     const ngnOption = currencyOptions.find(opt =>
    //         opt.code?.toUpperCase() === "NGN" ||
    //         opt.label?.toUpperCase().includes("NAIRA")
    //     );
    //     if (ngnOption) {
    //         setSelectedCurrency(ngnOption);
    //     }
    // };

    // const handleClose2 = () => {
    //     setShow2(false);
    //     // Reset form fields
    //     setDescription("");
    //     setAmount("");
    //     setCustomerName("");
    //     setPaymentDate("");
    //     setSelectedRadio("");
    //     setSelectedBank(null);
    //     setSelectedBank2(null);
    //     setSelectedCustomer(null);
    //     setSelectedPaymentMode(null);
    //     // Keep NGN selected or reset to NGN
    //     const ngnOption = currencyOptions.find(opt =>
    //         opt.code?.toUpperCase() === "NGN" ||
    //         opt.label?.toUpperCase().includes("NAIRA")
    //     );
    //     if (ngnOption) {
    //         setSelectedCurrency(ngnOption);
    //     }
    // };

    // Fetch cash and bank (credit select)
    useEffect(() => {
        const fetchBank = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.gl_name }))
                    : [];
                setBankOptions(options);
            } catch (err) {
                setBankOptions([]);
            }
        };
        fetchBank();
    }, []);

    // Fetch cash and bank (debit select)
    useEffect(() => {
        const fetchBank2 = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.gl_name }))
                    : [];
                setBankOptions2(options);
            } catch (err) {
                setBankOptions2([]);
            }
        };
        fetchBank2();
    }, []);

    // Fetch payment modes
    useEffect(() => {
        const fetchPaymentMode = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/income/get-payment-method`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.name }))
                    : [];
                setPaymentMode(options);
            } catch (err) {
                setPaymentMode([]);
            }
        };
        fetchPaymentMode();
    }, []);

    // Fetch beneficiaries (suppliers)
    useEffect(() => {
        const fetchBeneficiaries = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => ({ value: item.id, label: item.name }))
                    : [];
                setCustomerOptions(options);
            } catch (err) {
                setCustomerOptions([]);
            }
        };
        fetchBeneficiaries();
    }, []);

    // Fetch pending purchase invoices for "Payment to" select
    useEffect(() => {
        const fetchInvoiceOptions = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_URL}/v1/fetch-pending-purchases-invoice`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });
                const options = Array.isArray(res.data?.data)
                    ? res.data.data.map(item => {
                        const supplierName = item.supplier?.name || item.supplier_name || item.reference || `Invoice ${item.id}`;
                        const invoiceNumber = item.invoice_number || item.reference || `INV-${item.id}`;

                        return {
                            value: item.id,
                            label: (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100%',
                                    minHeight: '24px'
                                }}>
                                    <span style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '180px',
                                        flex: '1',
                                        fontSize: '14px',
                                        lineHeight: '1.2'
                                    }}>
                                        {supplierName}
                                    </span>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#666',
                                        marginLeft: '8px',
                                        flexShrink: 0,
                                        fontWeight: '500',
                                        backgroundColor: '#f8f9fa',
                                        padding: '2px 6px',
                                        borderRadius: '4px',
                                        border: '1px solid #e9ecef'
                                    }}>
                                        {invoiceNumber}
                                    </span>
                                </div>
                            ),
                            balance: item.balance,
                            invoiceNumber: invoiceNumber,
                            supplierName: supplierName
                        };
                    })
                    : [];
                setInvoiceOptions(options);
            } catch (err) {
                setInvoiceOptions([]);
            }
        };
        fetchInvoiceOptions();
    }, []);


    const getDeliveryStatus = (item) => {
        if (item.is_supplied == 1) return { text: "Delivered", class: classes.greenStatus };
        if (item.is_supplied == 0) return { text: "Pending", class: classes.yellowStatus };

        // Fallback to numeric status if is_supplied is null
        if (item.status == "0") return { text: "Pending", class: classes.yellowStatus };
        if (item.status == "1") return { text: "Delivered", class: classes.greenStatus };
        if (item.status == "2") return { text: "Overdue", class: classes.redStatus };

        // return { text: "Pending", class: classes.yellowStatus }; // default
    };

    const getPaymentStatus = (item) => {
        const paid = Number(item.paid || 0);
        const amount = Number(item.amount || 0);
        const balance = Number(item.balance || 0);

        if (balance > 0) return { text: "Pending", class: classes.yellowStatus };
        if (balance == 0) return { text: "Paid", class: classes.greenStatus };
        if (paid == amount) return { text: "Paid", class: classes.greenStatus };

        // return { text: "Pending", class: classes.yellowStatus }; // fallback
    };


    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const addPayment = async () => {
        setAddPaymenntLoad(true);
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.post(
                `${BASE_URL}/v1/pay-purchase-invoice`,

                {
                    payment_type: selectedRadio,
                    transaction_date: paymentDate,
                    supplier_id: selectedCustomer?.value,
                    supplier: customerName,
                    description: description,
                    payment_mode: selectedPaymentMode?.value,
                    currency: selectedCurrency?.value,
                    amount: amount,
                    credit: selectedBank?.value,
                    debit: selectedBank2?.value,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });

            Swal.fire({
                imageUrl: verified,
                title: 'Success!',
                text: response.data.message,
                confirmButtonText: "Okay",
                imageWidth: 48,
                imageHeight: 48,
                customClass: {
                    title: classes.myTitle,
                    popup: classes.myText,
                    confirmButton: classes.myButton,
                },
                allowOutsideClick: false,
                preConfirm: () => {
                    Swal.close();
                }
            });

            fetchInvoices();
            handleClose1();
            setDescription("");
            setAmount("");
            setCustomerName("");
            setPaymentDate("");
            setSelectedRadio("");
            setSelectedBank(null);
            setSelectedBank2(null);
            setSelectedCurrency(null);
            setSelectedCustomer(null);
            setSelectedPaymentMode(null);

        } catch (error) {
            let errorMessage = "An error occurred. Please try again.";
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                if (typeof error.response.data.message === "string") {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join("; ");
                } else if (typeof error.response.data.message === "object") {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                Swal.fire({
                    imageUrl: crop,
                    imageWidth: 48,
                    imageHeight: 48,
                    title: "Failed!",
                    confirmButtonText: "Okay",
                    text: JSON.stringify(error.response.data.message),
                    customClass: {
                        title: classes.myTitle,
                        popup: classes.myText,
                        confirmButton: classes.myDeclineButton,
                    },
                    allowOutsideClick: false, // Prevent closing by clicking outside
                    preConfirm: () => {
                        Swal.close(); // Explicitly close the modal
                    },
                });
            }
        } finally {
            setAddPaymenntLoad(false);
        }
    };

    const addPayment2 = async () => {
        setAddPaymenntLoad2(true);
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.post(
                `${BASE_URL}/v1/pay-supplier-purchase-invoice`,

                {
                    // payment_type: selectedRadio,
                    transaction_date: paymentDate,
                    id: selectedInvoice?.value,
                    description: description,
                    payment_mode: selectedPaymentMode?.value,
                    currency: selectedCurrency?.value,
                    amount: amount,
                    credit: selectedBank?.value,
                    debit: selectedBank2?.value,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                });

            Swal.fire({
                imageUrl: verified,
                title: 'Success!',
                text: response.data.message,
                confirmButtonText: "Okay",
                imageWidth: 48,
                imageHeight: 48,
                customClass: {
                    title: classes.myTitle,
                    popup: classes.myText,
                    confirmButton: classes.myButton,
                },
                allowOutsideClick: false,
                preConfirm: () => {
                    Swal.close();
                }
            });

            fetchInvoices();
            handleClose2();
            setDescription("");
            setAmount("");
            setCustomerName("");
            setPaymentDate("");
            setSelectedRadio("");
            setSelectedBank(null);
            setSelectedBank2(null);
            setSelectedCurrency(null);
            setSelectedCustomer(null);
            setSelectedPaymentMode(null);

        } catch (error) {
            let errorMessage = "An error occurred. Please try again.";
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                if (typeof error.response.data.message === "string") {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join("; ");
                } else if (typeof error.response.data.message === "object") {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                Swal.fire({
                    imageUrl: crop,
                    imageWidth: 48,
                    imageHeight: 48,
                    title: "Failed!",
                    confirmButtonText: "Okay",
                    text: JSON.stringify(error.response.data.message),
                    customClass: {
                        title: classes.myTitle,
                        popup: classes.myText,
                        confirmButton: classes.myDeclineButton,
                    },
                    allowOutsideClick: false, // Prevent closing by clicking outside
                    preConfirm: () => {
                        Swal.close(); // Explicitly close the modal
                    },
                });
            }
        } finally {
            setAddPaymenntLoad2(false);
        }
    };

    // Add useEffect to prevent background scrolling when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup function to restore scrolling when component unmounts
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);




    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}
                        onClick={() => navigate('/transactions/sales-invoice/sale')}>Sales Invoice</button>
                    <button className={classes.btns}
                        onClick={() => navigate('/inventory/PurchaseOrder')}>Purchase Invoice</button>
                    <button className={classes.btnsq}>Payables</button>
                    <button className={`${classes.btns} ${classes.greens}`}
                        onClick={() => navigate('/settings/product-services')}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Payables</h2>
                    <h1 className={classes.Titles}>
                        Track outstanding supplier invoices and manage payments.                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Outstanding</p>
                                <p className={classes.kdptg1}>₦5,900,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>All recievables</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Current (0-30 days)</p>
                                <p className={classes.kdptg2}>₦2,700,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Not yet due</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>1-30 Days Overdue</p>
                                <p className={classes.kdptg3}>₦3,200,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Reciveables overdue</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>31-60 Days Overdue</p>
                                <p className={classes.kdptg4}>₦0.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Urgent payment</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.thrdkad1}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>60+ Days Overdue</p>
                                <p className={classes.kdptg5}>₦0.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Critical</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search sales" />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Status</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <button className={classes.btnss}
                        // onClick={handleShow2}
                        onClick={() => setIsOpen(true)}
                    >Create Payables</button>
                </div>



                <div className={classes.invoicecont}>
                    <table className={classes.invoiceTable}>
                        <table className={classes.invoiceTable}>
                            <thead style={{ whiteSpace: "nowrap" }}>
                                <tr>
                                    <th>S/N</th>
                                    <th>Invoice Number</th>
                                    {/* <th>Description</th> */}
                                    <th>Supplier Name</th>
                                    <th>Transaction Date</th>
                                    <th>Delivery Status</th>
                                    <th>Payment Status</th>
                                    <th>Amount</th>
                                    <th>Post Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading
                                    ? Array(5)
                                        .fill()
                                        .map((_, idx) => (
                                            <tr key={idx}>
                                                {Array(9) // 9 columns now (not 10 anymore)
                                                    .fill()
                                                    .map((_, i) => (
                                                        <td key={i}>
                                                            <Skeleton height={20} style={{ marginBottom: 10 }} />
                                                        </td>
                                                    ))}
                                            </tr>
                                        ))
                                    : invoices.length === 0 ? (
                                        <tr>
                                            <td colSpan={9} style={{ textAlign: "center" }}>
                                                No purchase invoices found.
                                            </td>
                                        </tr>
                                    ) : (
                                        invoices.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.invoice_number || item.document_number || item.uuid}</td>
                                                {/* <td>{item.description}</td> */}
                                                <td>{item.supplier?.name || ""}</td>
                                                <td>{item.transaction_date}</td>

                                                {/* Delivery Status */}
                                                <td className={getDeliveryStatus(item).class}>
                                                    {getDeliveryStatus(item).text}
                                                </td>

                                                {/* Payment Status */}
                                                <td className={getPaymentStatus(item).class}>
                                                    {getPaymentStatus(item).text}
                                                </td>

                                                {/* Amount */}
                                                <td style={{textAlign:'right'}}>{Number(item.supplied_amount).toLocaleString()}</td>

                                                {/* Post Date */}
                                                <td>{item.created_at ? item.created_at.split("T")[0] : ""}</td>

                                                {/* Actions */}
                                                <td className={classes.actionss}>
                                                    <Pen size={16} className={classes.editIcon} />
                                                    <Trash2 size={16} className={classes.deleteIcon} />
                                                    <Printer
                                                        size={16}
                                                        className={classes.printIcon}
                                                        onClick={() => handlePrint(item)}
                                                        style={{ cursor: "pointer", color: 'rgb(37, 99, 235)' }}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    )}
                            </tbody>

                        </table>


                    </table>

                    <div className={classes.paginationContainer}>
                        <div className={classes.paginationControls}>
                            <button>First</button>
                            <button className={classes.active}>1</button>
                            <button>Last</button>
                            <span className={classes.pageText}>Displaying 1 - 41 of 41</span>
                        </div>
                    </div>


                </div>

                {/* <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                    </tfoot>
                </table> */}

                {/* <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div> */}
            </div>

            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="New Payable"
                addPayment2={addPayment2}
                addpaymenntLoad2={addpaymenntLoad2}
                invoiceOptions={invoiceOptions}
                selectedInvoice={selectedInvoice}
                setSelectedInvoice={setSelectedInvoice}
                setAmount={setAmount}
                amount={amount}
                paymentDate={paymentDate}
                setPaymentDate={setPaymentDate}
                description={description}
                setDescription={setDescription}
                paymentMode={paymentMode}
                selectedPaymentMode={selectedPaymentMode}
                setSelectedPaymentMode={setSelectedPaymentMode}
                currencyOptions={currencyOptions}
                selectedCurrency={selectedCurrency}
                setSelectedCurrency={setSelectedCurrency}
                bankOptions={bankOptions}
                selectedBank={selectedBank}
                setSelectedBank={setSelectedBank}
                bankOptions2={bankOptions2}
                selectedBank2={selectedBank2}
                setSelectedBank2={setSelectedBank2}
                classes={classes}
            >
                <Form className={classes.compactForm}>
                    <Form.Group controlId="exampleForm.ControlInput1">
                        <div className={classes.compactRowtackled}>
                            <label>Payment to:</label>
                            <Select
                                options={invoiceOptions}
                                value={selectedInvoice}
                                onChange={(option) => {
                                    setSelectedInvoice(option);
                                    setAmount(option?.balance || "");
                                }}
                                placeholder="Select Supplier"
                                isClearable
                                classNamePrefix="react-select"
                                required
                                className={classes.fullWidth}
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Date:</label>
                            <input
                                type="date"
                                value={paymentDate}
                                onChange={e => setPaymentDate(e.target.value)}
                                required
                                className={classes.fullWidth}
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Description:</label>
                            <Form.Control
                                as="textarea"
                                value={description}
                                rows={1}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                                    setDescription(filteredValue);
                                }}
                                required
                                className={classes.fullWidth}
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Mode:</label>
                            <Select
                                options={paymentMode}
                                value={selectedPaymentMode}
                                onChange={setSelectedPaymentMode}
                                placeholder="Select Payment Mode"
                                isClearable
                                classNamePrefix="react-select"
                                required
                                className={classes.fullWidth}
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Currency:</label>
                            <Select
                                options={currencyOptions}
                                value={selectedCurrency}
                                onChange={setSelectedCurrency}
                                placeholder="Choose currency"
                                isClearable
                                classNamePrefix="react-select"
                                required
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Amount:</label>
                            <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                                readOnly
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Credit:</label>
                            <Select
                                options={bankOptions}
                                value={selectedBank}
                                onChange={setSelectedBank}
                                placeholder="Account"
                                isClearable
                                classNamePrefix="react-select"
                                required
                                className={classes.fullWidth}
                            />
                        </div>

                        <div className={classes.compactRowtackled}>
                            <label>Debit:</label>
                            <Select
                                options={bankOptions2}
                                value={selectedBank2}
                                onChange={setSelectedBank2}
                                placeholder="Account"
                                isClearable
                                classNamePrefix="react-select"
                                required
                                className={classes.fullWidth}
                            />
                        </div>
                    </Form.Group>
                </Form>
            </Modal>

            <Modal
                show={show2}
                onHide={handleClose2}
                animation={false}
                dialogClassName={classes.modalDialog}
                contentClassName={classes.modalContent}
                backdropClassName={classes.modalBackdrop}
                centered
            >
                <Modal.Header closeButton className={classes.modalHeader}>
                    <Modal.Title className={classes.modalTitle}>New Payable</Modal.Title>
                </Modal.Header>
                <Modal.Body className={classes.modalBody}>
                    <Form className={classes.compactForm}>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <div className={classes.compactRowtackled}>
                                <label>Payment to:</label>
                                <Select
                                    options={invoiceOptions}
                                    value={selectedInvoice}
                                    onChange={(option) => {
                                        setSelectedInvoice(option);
                                        setAmount(option?.balance || "");
                                    }}
                                    placeholder="Select Supplier"
                                    isClearable
                                    classNamePrefix="react-select"
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Date:</label>
                                <input
                                    type="date"
                                    value={paymentDate}
                                    onChange={e => setPaymentDate(e.target.value)}
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Description:</label>
                                <Form.Control
                                    as="textarea"
                                    value={description}
                                    rows={1}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                                        setDescription(filteredValue);
                                    }}
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Mode:</label>
                                <Select
                                    options={paymentMode}
                                    value={selectedPaymentMode}
                                    onChange={setSelectedPaymentMode}
                                    placeholder="Select Payment Mode"
                                    isClearable
                                    classNamePrefix="react-select"
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Currency:</label>
                                <Select
                                    options={currencyOptions}
                                    value={selectedCurrency}
                                    onChange={setSelectedCurrency}
                                    placeholder="Currency"
                                    isClearable
                                    classNamePrefix="react-select"
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Amount:</label>
                                <CurrencyInput
                                    id="total-amount"
                                    name="totalAmount"
                                    value={amount}
                                    decimalsLimit={2}
                                    onValueChange={(value) => setAmount(value)}
                                    prefix="₦"
                                    groupSeparator=","
                                    placeholder="Amount"
                                    className={`form-control ${classes.optioncss}`}
                                    readOnly
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Credit:</label>
                                <Select
                                    options={bankOptions}
                                    value={selectedBank}
                                    onChange={setSelectedBank}
                                    placeholder="Account"
                                    isClearable
                                    classNamePrefix="react-select"
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>

                            <div className={classes.compactRowtackled}>
                                <label>Debit:</label>
                                <Select
                                    options={bankOptions2}
                                    value={selectedBank2}
                                    onChange={setSelectedBank2}
                                    placeholder="Account"
                                    isClearable
                                    classNamePrefix="react-select"
                                    required
                                    className={classes.fullWidth}
                                />
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className={classes.modalFooter}>
                    <Button variant="danger" onClick={handleClose2} className={classes.modalBtnSecondary}>
                        Go back
                    </Button>
                    <Button variant="success" onClick={addPayment2} disabled={addpaymenntLoad2} className={classes.modalBtnPrimary}>
                        {addpaymenntLoad2 ? (
                            <>
                                <Spinner size="sm" />
                                <span style={{ marginLeft: "5px" }}>
                                    Processing, Please wait...
                                </span>
                            </>
                        ) : (
                            "Save Payment"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />
        </div>
    );
};

export default Payables;
